import React from "react";
import DetailCard from "../../../../components/display/DetailCard";
import { useTranslation } from "react-i18next";
import useUser from "../../../../hooks/useUser";

export default function ClinicInformation({ clinic }) {
  const { t } = useTranslation();
  const { roles } = useUser();
  let fields = [
    { key: "title", label: "Title" },
    { key: "shortName", label: "ShortName" },
    { key: "city", label: "City" },
    { key: "streetAddress", label: "StreetAddress" },
    { key: "zipCode", label: "ZipCode" },
    { key: "phoneNumber", label: "PhoneNumber" },
    { key: "email", label: "Email" },
    { key: "country", label: "Country" },
    { key: "url", label: "Url" },
  ];

  if (roles.master) {
    fields.push({ key: "hidden", label: "Hidden" });
  }

  const clinicArr = fields
    .map((field) => ({
      title: t(field.label),
      value: field.key === "url" ? clinic[field.key] : t(clinic[field.key]),
      testId: `clinic.details.${field.key}`,
    }))
    .filter(
      (item) =>
        item.value != null && item.value != undefined && item.value != ""
    );

  return <DetailCard valueArray={clinicArr} grid gridCount={2} />;
}
